/**
 * ARCHIVO TEMPORAL - ELIMINAR CUANDO EL BACKEND FUNCIONE CORRECTAMENTE
 * Este archivo contiene datos mock para las órdenes de finanzas cuando el backend no devuelve datos
 */

import { IProductList } from 'types/orders';

export const mockPendingOrders: IProductList[] = [
  {
    id: 'mock-pending-1',
    orderId: 1001,
    organizationName: 'Organización Ejemplo 1',
    organizationId: 121,
    statusName: 'Pendiente de confirmación',
    statusId: 1,
    createdAt: new Date().toISOString(),
    total: '1000',
    totalUsd: '100',
    currency: 'MXN',
    countriesShipments: [
      {
        id: 1,
        name: 'México',
        code: 'MX',
        flag: 'https://www.countryflags.com/wp-content/uploads/mexico-flag-png-large.png'
      }
    ]
  }
];

export const mockConfirmedOrders: IProductList[] = [
  {
    id: 'mock-confirmed-1',
    orderId: 1002,
    organizationName: 'Organización Ejemplo 2',
    organizationId: 121,
    statusName: 'Confirmado',
    statusId: 2,
    createdAt: new Date().toISOString(),
    total: '2000',
    totalUsd: '200',
    currency: 'MXN',
    countriesShipments: [
      {
        id: 1,
        name: 'México',
        code: 'MX',
        flag: 'https://www.countryflags.com/wp-content/uploads/mexico-flag-png-large.png'
      }
    ]
  }
];

export const mockDeliveredOrders: IProductList[] = [
  {
    orderId: 4498,
    organizationName: 'Britney Soluciones',
    organizationId: 459,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 3,
      name: 'Colombia',
      code: 'co',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
    },
    paymentType: 'Transf. CLP',
    currency: 'CLP',
    total: '7408.3',
    totalUsd: '322.1',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: 'https://d2bb2hf1hp3ih3.cloudfront.net/files/2c4d2736-d0ea-4c0e-80df-3202657d21e4.pdf',
    commitedPaymentDate: '2025-12-19T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'Chile',
        flag: 'https://cdn.britannica.com/85/7485-004-00B07230/Flag-Chile.jpg'
      }
    ],
    createdAt: '2025-12-10T16:49:39.000Z',
    cancelledDate: null,
    deliveryDate: '2025-12-20T17:00:00.000Z',
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: false,
    hasPendingConfig: false,
    responsibleIds: [1458],
    id: '4498'
  },
  {
    orderId: 4481,
    organizationName: 'Britney Soluciones',
    organizationId: 459,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 3,
      name: 'Colombia',
      code: 'co',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
    },
    paymentType: 'Crédito Bord MXN',
    currency: 'MXN',
    total: '1200',
    totalUsd: '1200',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-12-19T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'México',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
      }
    ],
    createdAt: '2025-12-05T15:40:16.000Z',
    cancelledDate: null,
    deliveryDate: '2025-12-13T19:00:00.000Z',
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: false,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '4481'
  },
  {
    orderId: 4480,
    organizationName: 'Britney Soluciones',
    organizationId: 459,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 3,
      name: 'Colombia',
      code: 'co',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
    },
    paymentType: 'Crédito Bord MXN',
    currency: 'MXN',
    total: '1200',
    totalUsd: '1200',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-12-19T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'México',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
      }
    ],
    createdAt: '2025-12-05T15:40:16.000Z',
    cancelledDate: null,
    deliveryDate: '2025-12-16T19:00:00.000Z',
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: false,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '4480'
  },
  {
    orderId: 4171,
    organizationName: 'Britney Soluciones',
    organizationId: 459,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 3,
      name: 'Colombia',
      code: 'co',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '2770',
    totalUsd: '2770',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-10-29T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'México',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
      }
    ],
    createdAt: '2025-10-15T18:55:50.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: false,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '4171'
  },
  {
    orderId: 4129,
    organizationName: 'Jean',
    organizationId: 455,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 3,
      name: 'Colombia',
      code: 'co',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '52500',
    totalUsd: '350',
    needInvoice: 'false',
    invoiceUrl: 'https://d2bb2hf1hp3ih3.cloudfront.net/files/e8181354-d16c-4c50-8c32-d75b03bf8b24.pdf',
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-10-19T23:59:59.000Z',
    statusName: 'Entregada',
    numberOfShipments: 2,
    countriesShipments: [
      {
        name: 'Colombia',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
      }
    ],
    createdAt: '2025-09-02T15:53:38.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: false,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '4129'
  },
  {
    orderId: 3474,
    organizationName: 'Britney Soluciones',
    organizationId: 459,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 3,
      name: 'Colombia',
      code: 'co',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '19950',
    totalUsd: '19950',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-07-11T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 2,
    countriesShipments: [
      {
        name: 'Colombia',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-e333000f-6c82-42c5-83d3-8dbd19da3d4b-447c-7a13-4nZAR6iMk-regular.png'
      }
    ],
    createdAt: '2025-06-26T19:00:00.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: true,
    hasPendingConfig: true,
    responsibleIds: [],
    id: '3474'
  },
  {
    orderId: 3314,
    organizationName: 'Compublancas',
    organizationId: 444,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 2,
      name: 'México',
      code: 'mx',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '2000',
    totalUsd: '2000',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-06-25T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'Argentina',
        flag: 'https://cdn.britannica.com/69/5869-004-7D75CD05/Flag-Argentina.jpg'
      }
    ],
    createdAt: '2025-05-26T19:00:00.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: true,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '3314'
  },
  {
    orderId: 3312,
    organizationName: 'Compublancas',
    organizationId: 444,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 2,
      name: 'México',
      code: 'mx',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '10320',
    totalUsd: '10320',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-04-30T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 2,
    countriesShipments: [
      {
        name: 'México',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
      }
    ],
    createdAt: '2025-03-31T19:00:00.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: true,
    hasPendingConfig: true,
    responsibleIds: [],
    id: '3312'
  },
  {
    orderId: 3290,
    organizationName: 'Nudos ',
    organizationId: 121,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 2,
      name: 'México',
      code: 'mx',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '3000',
    totalUsd: '3000',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-05-24T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'México',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
      }
    ],
    createdAt: '2025-04-24T19:00:00.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: true,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '3290'
  },
  {
    orderId: 3138,
    organizationName: 'Nudos',
    organizationId: 205,
    levelSubscription: 'Lite',
    countryOrganization: {
      id: 2,
      name: 'México',
      code: 'mx',
      flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
    },
    paymentType: 'Transf. USD',
    currency: 'USD',
    total: '1620',
    totalUsd: '1620',
    needInvoice: 'false',
    invoiceUrl: null,
    paymentLink: null,
    proofOfPaymentUrl: null,
    commitedPaymentDate: '2025-04-30T19:00:00.000Z',
    statusName: 'Entregada',
    numberOfShipments: 1,
    countriesShipments: [
      {
        name: 'México',
        flag: 'https://d2bb2hf1hp3ih3.cloudfront.net/images/country-img-1cde2f24-e803-44d6-92e4-c07ccec3c61d-2b47-97bb-S7BvVrw5Q-regular.png'
      }
    ],
    createdAt: '2025-03-31T19:00:00.000Z',
    cancelledDate: null,
    deliveryDate: null,
    reasonToCancel: null,
    orderTemporaryStorageReasons: [],
    editShipment: [],
    hasConfig: false,
    hasPendingConfig: false,
    responsibleIds: [],
    id: '3138'
  }
];

export const mockCancelledOrders: IProductList[] = [
  {
    id: 'mock-cancelled-1',
    orderId: 1004,
    organizationName: 'Organización Ejemplo 4',
    statusName: 'Cancelada',
    statusId: 4,
    createdAt: new Date().toISOString(),
    cancelledDate: new Date().toISOString(),
    total: '4000',
    totalUsd: '400',
    currency: 'MXN',
    countriesShipments: [
      {
        id: 1,
        name: 'México',
        code: 'MX',
        flag: 'https://www.countryflags.com/wp-content/uploads/mexico-flag-png-large.png'
      }
    ]
  }
];
